import React from 'react';
import "./about.css";
import Image from "../../assets/corpoCompleto.png";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import AboutBox from './AboutBox';
import { useLanguage } from '../../context/LanguageContext';

ChartJS.register(ArcElement, Tooltip,Legend)

const createMarkup = (text) => {
  return { __html: text };
};

const About = () => {

  const { translations } = useLanguage();

  const data = {
    labels: ['Java', 'Angular', 'React'],
    datasets: [
      {
        data: [60, 20, 20],
        backgroundColor: ['#ff5063', '#4ed4b6', '#7171e6']
      }
    ]
  };

  return (
    <section className="about container section" id="about">
      <h2 className="section__title">{translations.aboutTitle}</h2>

      <div className="about__container grid">
        <img src={Image} alt="" className="about__img" />

        <div className="about__data grid">
          <div className="about__info">
            <p className="about__description">{translations.aboutDescription.split('*').map((line, index) => (
              <p key={index} dangerouslySetInnerHTML={createMarkup(line.trim())}></p>
            ))}
        </p>
             <a href={translations.language === 'pt' ? "https://drive.google.com/uc?export=download&id=1iOzCxMlwu74CvAZBOKf3EV8YoQyhsEKC" : "https://drive.google.com/uc?export=download&id=1gpzz2GSkmtLXTDc35VAvHfeZf9J0N1r6"} className="btn" download> {translations.downloadCV} </a>
          </div>
          
          <div className="about__skills grid">
            <Pie
              data = {data}
              options= {{
                plugins: {
                  legend: {
                    display: false
                  }
                }
              }}
            />
            <div className="legend-container">
              {data.labels.map((label, index) => (
                <div key={index} className="legend-badge">
                  <span className="legend-color" style={{ backgroundColor: data.datasets[0].backgroundColor[index] }}></span>
                  <span className="legend-text">{label}</span>
                </div>
              ))}
            </div>
        </div>
      </div>
    </div>

      <AboutBox/>
    </section>
  )
}

export default About